import { generateClient } from 'aws-amplify/api';
import { getCurrentUser } from 'aws-amplify/auth';
import * as mutations from '../graphql/mutations';
import * as queries from '../graphql/queries';

const client = generateClient();

export const getPathfinderIMTDomainKeyByIndex = (index) => {
  const domainKeys = [
    "MRCP(UK)",
    "Postgraduate Degrees",
    "Presentations/Posters",
    "Publications",
    "Quality Improvement",
    "Teaching Experience",
    "Additional Error for IMT"
  ];
  
  const numericIndex = Number(index);
  console.log(`Converting Pathfinder IMT domain index ${index} to key: ${numericIndex}`);
  
  if (isNaN(numericIndex)) {
    console.error(`Invalid Pathfinder IMT domain index: ${index}`);
    return `Unknown domain ${index}`;
  }
  
  const result = domainKeys[numericIndex];
  return result || `Unknown domain ${index}`;
};

const isNumericDomainKey = (key) => {
  return !isNaN(Number(key)) && key !== null && key !== '';
};

export const savePathfinderIMTDomainScore = async (domainKey, points) => {
  try {
    const textDomainKey = isNumericDomainKey(domainKey) 
      ? getPathfinderIMTDomainKeyByIndex(Number(domainKey))
      : domainKey;
    
    const user = await getCurrentUser();
    if (!user) throw new Error('User not authenticated');

    console.log(`Saving PathfinderIMTDomainScore: domainKey="${textDomainKey}", points=${points}`);

    const { data } = await client.graphql({
      query: queries.listPathfinderIMTDomainScores,
      variables: {
        filter: { 
          userId: { eq: user.username }, 
          domainKey: { eq: textDomainKey }
        }
      },
      authMode: 'userPool'
    });

    const existingRecord = data.listPathfinderIMTDomainScores.items[0];

    if (existingRecord) {
      const input = {
        id: existingRecord.id,
        userId: user.username,
        domainKey: textDomainKey,
        progress: points,
        owner: user.username,
        _version: existingRecord._version
      };

      console.log('Updating existing record with input:', input);
      const result = await client.graphql({
        query: mutations.updatePathfinderIMTDomainScore,
        variables: { input },
        authMode: 'userPool'
      });
      
      console.log('Update successful:', result);
      return result;
    } else {
      const input = {
        userId: user.username,
        domainKey: textDomainKey,
        progress: points,
        owner: user.username
      };

      console.log('Creating new record with input:', input);
      const result = await client.graphql({
        query: mutations.createPathfinderIMTDomainScore,
        variables: { input },
        authMode: 'userPool'
      });
      
      console.log('Create successful:', result);
      return result;
    }
  } catch (error) {
    console.error('Error saving Pathfinder IMT domain score:', error);
    throw error;
  }
};

export const fetchAllPathfinderIMTDomainScores = async () => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error('User not authenticated');

    const { data } = await client.graphql({
      query: queries.listPathfinderIMTDomainScores,
      variables: {
        filter: { userId: { eq: user.username } },
        limit: 100
      },
      authMode: 'userPool'
    });

    return data.listPathfinderIMTDomainScores.items;
  } catch (error) {
    console.error('Error fetching Pathfinder IMT domain scores:', error);
    return [];
  }
};

